import { AppBoy, HanaLog, GoogleTagManager, AppShare } from 'hnt-utils'
import { getCookie } from '@/util/methods'
import { deployEnv } from '~/config'

export default {
  install: (Vue, store) => {
    const stage = deployEnv === 'prod' ? 'prod' : 'dev'

    // 사용자 정보 설정
    if (store.state.auth.isLogged) {
      store.commit('SET_CUSTOMER_INFO', {
        /*
          닷컴을 통해서 들어오는 경우 uid 쿠키가 있어 사용자 이메일을 그대로 전송하지만 없을 경우 store에 있는 사용자 이메일을 넣어준다.
          store에 있는 이메일은 FND 사용자 정보 조회에서 받은 사용자 이메일로서 마스킹 처리되어 있다.
          마스킹된채로 전송할지에 대해 팀장님과 얘기해봤는데 일단 그대로 전송하기로 했다.
          유관부서에서 이와 관련해서 이슈를 제기하면 마스킹 해제를 고려해봐야한다.
        */
        customerId: getCookie('uid') ?? store.state.auth.loggedUser?.email,
        customerNumber:
          getCookie('fnd-uidx') ?? store.state.auth.loggedUser?.hntUid?.split('_')?.[0],
      })
    }

    // appShare 전역 객체로 등록
    Vue.prototype.$appShare = AppShare()
    // hanalog 전역 객체로 등록
    Vue.prototype.$hanaLog = HanaLog({}, store, stage)
    // appboy 전역 객체로 등록
    Vue.prototype.$appBoy = AppBoy({}, store, stage)

    // 구글 태그매니저 script 생성
    GoogleTagManager({}, store)
  },
}
